import { useState } from 'react';
import { Confirm, useDelete, useNotify, useRecordContext, useRedirect, useResourceContext } from 'react-admin';

import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';

import { DeleteConfirmation } from '@app/components/common/Table/DefaultTable/types';

interface CustomDeleteButtonProps {
  resourceSingular: string;
  resolveDeleteConfirmation?(resourceId: number): Promise<DeleteConfirmation>;
}

export const CustomDeleteButton = ({ resolveDeleteConfirmation, resourceSingular }: CustomDeleteButtonProps) => {
  const notify = useNotify();
  const { id } = useRecordContext();
  const resource = useResourceContext();

  const redirect = useRedirect();
  const [deleteOne, { isLoading }] = useDelete(resource, { id });
  const [isConfirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmContent, setConfirmContent] = useState(`Are you sure you want to this ${resourceSingular}?`);

  const handleDialogToggle = (isOpened: boolean) => {
    setConfirmationOpen(isOpened);
  };

  const handleDelete = async () => {
    await deleteOne();
    redirect(`/${resource}`);
  };

  const handleConfirmation = async () => {
    if (resolveDeleteConfirmation) {
      const deleteConfirm = await resolveDeleteConfirmation(id as number);
      if (!deleteConfirm.deletable) {
        notify(deleteConfirm.message || '', { type: 'error' });
        return;
      }
      if (deleteConfirm.message) {
        setConfirmContent(deleteConfirm.message);
      }
    }
    setConfirmationOpen(true);
  };

  return (
    <>
      <Button disabled={isLoading} onClick={handleConfirmation} startIcon={<DeleteIcon />} color="error">
        Delete
      </Button>
      <Confirm
        isOpen={isConfirmationOpen}
        title={`Delete ${resourceSingular}`}
        content={confirmContent}
        onConfirm={handleDelete}
        cancel="Back to edit"
        confirm="Delete"
        onClose={() => handleDialogToggle(false)}
      />
    </>
  );
};
